export default __webpack_public_path__ + "static/media/03 - SKS NITHYAM JEWELLERS logo Final - PNG.1d1249a0.png";